import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { createHigherOrderComponent } from '@wordpress/compose';
import { Fragment } from '@wordpress/element';
import { CustomSelectControl, Panel, PanelBody } from '@wordpress/components';
import { InspectorControls } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
const defaultSizes = [{
  name: __('Small', 'media-manager'),
  slug: 'small',
  key: 'key-small',
  size: 1
}, {
  name: __('Normal', 'media-manager'),
  slug: 'normal',
  key: 'key-normal',
  size: 1.5
}, {
  name: __('Medium', 'media-manager'),
  slug: 'medium',
  key: 'key-medium',
  size: 2
}, {
  name: __('Large', 'media-manager'),
  slug: 'large',
  key: 'key-large',
  size: 2.5
}, {
  name: __('Giant', 'media-manager'),
  slug: 'giant',
  key: 'key-giant',
  size: 4
}];
export function getButtonSizeBySlug(slug) {
  var _defaultSizes$find;

  return ((_defaultSizes$find = defaultSizes.find(option => option.slug === slug)) === null || _defaultSizes$find === void 0 ? void 0 : _defaultSizes$find.size) || 1.5;
}
export function withSizes(supportProps) {
  return createHigherOrderComponent(BlockEdit => props => {
    var _supportProps$options;

    const {
      attributes,
      setAttributes
    } = props;
    const {
      size
    } = attributes;
    const scale = getButtonSizeBySlug(size);

    function setSize({
      selectedItem
    }) {
      if (!(selectedItem !== null && selectedItem !== void 0 && selectedItem.slug)) {
        return;
      }

      setAttributes({
        size: selectedItem.slug
      });
    } // Panel title.


    const panelTitle = supportProps.__sectionTitle;

    const selectorTitle = supportProps.__selectorTitle || __('Sizes', 'media-manager');

    const sizes = (_supportProps$options = supportProps === null || supportProps === void 0 ? void 0 : supportProps.options) !== null && _supportProps$options !== void 0 ? _supportProps$options : defaultSizes;
    return createElement(Fragment, null, createElement(InspectorControls, null, createElement(Panel, null, createElement(PanelBody, {
      title: panelTitle
    }, createElement(CustomSelectControl, {
      label: selectorTitle,
      options: sizes,
      onChange: setSize,
      value: sizes.find(option => option.slug === size)
    })))), createElement(BlockEdit, _extends({}, props, {
      scale: scale
    })));
  }, 'withSizes');
}
//# sourceMappingURL=index.js.map